import { i18n } from '@/i18n'

export default () => {
  return [
    {
      icon: 'config',
      name: i18n.t('app.notifications') + ' ',
      // name: i18n.t('app.notifications'),
      path: 'notifications',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          // name: i18n.t('app.new_notification'),
          path: 'notification/new',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('app.tags_link'),
        //   path: 'redirect',
        //   disabled: true,
        //   registerNavFromMenu: false,
        //   sc: [] // shorcuts
        // },
        // {
        //   name: i18n.t('app.historical'),
        //   path: 'redirect',
        //   disabled: true,
        //   registerNavFromMenu: false,
        //   sc: [] // shorcuts
        // }
      ]
    }
  ]
}
